import {Controller} from "@hotwired/stimulus";
import {useModal} from "../js/stimulus_use/use-modal";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        shouldOpen: Boolean,
    };

    connect() {
        useModal(this);

        if (this.shouldOpenValue) {
            this.open();
        }
    }
}
